/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { constants } from "../constants/Constants";

const productionLog = () => null;

const productionDebugLog = productionLog;
const productionDebugWarn = productionLog;
const productionDebugError = productionLog;

const developmentDebugLog = console.log;
const developmentDebugWarn = console.warn;
const developmentDebugError = console.error;

const isDevelopment = constants.debug || constants.server === "stage";
const debug = isDevelopment ? {
  log: developmentDebugLog,
  warn: developmentDebugWarn,
  error: developmentDebugError
} : {
  log: productionDebugLog,
  warn: productionDebugWarn,
  error: productionDebugError
};

export default debug;
